import { Armchair, GlassWater, Camera, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const FEATURES = [
  {
    icon: Armchair,
    title: "Cleaner Interiors",
    body: "Every vehicle is cleaned and prepared to excellence.",
  },
  {
    icon: GlassWater,
    title: "Water & Tissues",
    body: "Complimentary water bottles and tissues with every ride.",
  },
  {
    icon: Camera,
    title: "Onboard Cameras",
    body: "Added safety and accountability for complete peace of mind.",
  },
  {
    icon: Sparkles,
    title: "Better Experience",
    body: "Smoother journeys with premium service standards.",
  },
];

export const WhyBettr = () => (
  <section
    id="about"
    data-testid="why-bettr"
    className="bg-cream text-dark py-16 sm:py-24 lg:py-[132px]"
  >
    <div className="container-bettr grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow>Why Bettr?</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif font-normal text-dark mt-6 text-[40px] sm:text-[54px] lg:text-[64px] leading-[1.0] tracking-[-0.02em]">
            It's the little things that make a big{" "}
            <span className="italic text-gold">difference.</span>
          </h2>
        </Reveal>
      </div>

      <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-12">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <Reveal
              key={f.title}
              delay={i * 0.09}
              data-testid={`why-feature-${i + 1}`}
              className="border-t border-dark/12 pt-6"
            >
              <Icon size={28} strokeWidth={1.5} className="text-gold mb-5" />
              <h3 className="font-sans text-dark font-semibold text-base mb-3">{f.title}</h3>
              <p className="font-sans text-dark/55 text-sm leading-relaxed max-w-[260px]">
                {f.body}
              </p>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
